var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Block } from "src/ts/blocks/Block";
export class Blocks {
    constructor(_redDot) {
        this.blockMap = {
            //"acf/accordion": () => import(/* webpackChunkName: "accordion" */ "blocks/accordion/Accordion").then(m => m.Accordion),
            //"acf/accordion-with-filters": () => import(/* webpackChunkName: "accordion-with-filters" */ "./accordion-with-filters/AccordionWithFilters").then(m => m.AccordionWithFilters),
            //"acf/article-content": () => import(/* webpackChunkName: "article-content" */ "./article-content/ArticleContent").then(m => m.ArticleContent),
            //"acf/article-quote": () => import(/* webpackChunkName: "article-quote" */ "blocks/article-quote/ArticleQuote").then(m => m.ArticleQuote),
            //"acf/case-study-listing": () => import(/* webpackChunkName: "case-study-listing" */ "./case-study-listing/CaseStudyListing").then(m => m.CaseStudyListing),
            //"acf/culture-cards": () => import(/* webpackChunkName: "culture-cards" */ "blocks/culture-cards/CultureCards").then(m => m.CultureCards),
            //"acf/event-track-accordion": () => import(/* webpackChunkName: "event-track-accordion" */ "./event-track-accordion/EventTrackAccordion").then(m => m.EventTrackAccordion),
            "acf/faq": () => import(/* webpackChunkName: "faq" */ "./faq/Faq").then(m => m.Faq),
            //"acf/frontpage-culture": () => import(/* webpackChunkName: "frontpage-culture" */ "./frontpage-culture/FrontpageCulture").then(m => m.FrontpageCulture),
            //"acf/hilite-lifts": () => import(/* webpackChunkName: "hilite-lifts" */ "./hilite-lifts/HiliteLifts").then(m => m.HiliteLifts),
            //"acf/industries-hero": () => import(/* webpackChunkName: "industries-hero" */ "blocks/industries-hero/IndustriesHero").then(m => m.IndustriesHero),
            //"acf/insights": () => import(/* webpackChunkName: "insights" */ "./insights/Insights").then(m => m.Insights),
            "acf/latest-news": () => import(/* webpackChunkName: "latest-news" */ "./latest-news/LatestNews").then(m => m.LatestNews),
            "acf/post-list": () => import(/* webpackChunkName: "post-list" */ "./post-list/PostList").then(m => m.PostList),
            //"acf/local-hero": () => import(/* webpackChunkName: "local-hero" */ "./local-hero/LocalHero").then(m => m.LocalHero),
            //"acf/media-bank": () => import(/* webpackChunkName: "media-bank" */ "./media-bank/MediaBank").then(m => m.MediaBank),
            //"acf/people-of": () => import(/* webpackChunkName: "people-of" */ "./people-of/PeopleOf").then(m => m.PeopleOf),
            //"acf/quote-carousel": () => import(/* webpackChunkName: "quote-carousel" */ "blocks/quote-carousel/QuoteCarousel").then(m => m.QuoteCarousel),
            //"acf/related-posts": () => import(/* webpackChunkName: "related-posts" */ "blocks/related-posts/RelatedPosts").then(m => m.RelatedPosts),
            //"acf/related-news": () => import(/* webpackChunkName: "related-news" */ "./related-news/RelatedNews").then(m => m.RelatedNews),
            //"acf/services-hero-2": () => import(/* webpackChunkName: "services-hero-2" */ "./services-hero-2/ServicesHero2").then(m => m.ServicesHero2),
            //"acf/services-intro": () => import(/* webpackChunkName: "services-intro" */ "./services-intro/ServicesIntro").then(m => m.ServicesIntro),
            //"acf/services-list": () => import(/* webpackChunkName: "services-list" */ "./services-list/ServicesList").then(m => m.ServicesList),
            //"acf/speakers": () => import(/* webpackChunkName: "speakers" */ "./speakers/Speakers").then(m => m.Speakers),
            //"acf/speakers-with-filters": () => import(/* webpackChunkName: "speakers-with-filters" */ "./speakers-with-filters/SpeakersWithFilters").then(m => m.SpeakersWithFilters),
            //"acf/speakers-simple": () => import(/* webpackChunkName: "speakers-simple" */ "./speakers-simple/SpeakersSimple").then(m => m.SpeakersSimple),
            //"acf/timetable-with-tracks": () => import(/* webpackChunkName: "timetable-with-tracks" */ "./timetable-with-tracks/TimetableWithTracks").then(m => m.TimetableWithTracks),
            block: () => Promise.resolve(Block),
        };
        this.adminBlocks = {};
        this.initializedElements = new WeakSet();
        this.loadedBlockClasses = {};
        this.domObserver = null;
        this.domScanQueued = false;
        this.adminReInitRequired = [
            "acf/article-quote",
            "acf/culture-cards",
            "acf/event-track-accordion",
            "acf/insights",
            "acf/latest-news",
            "acf/post-list",
            "acf/people-of-jhl-infra",
            "acf/related-news",
            "acf/related-press-releases",
            "acf/related-posts",
            "acf/speakers",
            "acf/speakers-simple",
            "acf/speakers-with-filters",
        ];
        this.blocks = [];
        this.initRenderedBlocks();
        this.bindEditorPreviewReRender();
        this.observeDomForNewBlocks();
    }
    initRenderedBlocks() {
        return __awaiter(this, void 0, void 0, function* () {
            const blockKeys = this.getRenderedBlockKeys();
            if (blockKeys.length === 0) {
                return;
            }
            try {
                yield Promise.all(blockKeys.map((blockKey) => this.loadBlockClass(blockKey)));
                for (const blockKey of blockKeys) {
                    this.initBlockInstancesInDom(blockKey);
                }
            }
            catch (error) {
                console.error("Error loading block chunks:", error);
            }
        });
    }
    bindEditorPreviewReRender() {
        const acfInstance = window.acf;
        if (!acfInstance || typeof acfInstance.addAction !== "function") {
            return;
        }
        acfInstance.addAction("render_block_preview", (blockElement, attributes) => __awaiter(this, void 0, void 0, function* () {
            yield this.onEditorBlockPreviewRender(blockElement, attributes);
        }));
    }
    observeDomForNewBlocks() {
        if (!document.body || typeof MutationObserver === "undefined") {
            return;
        }
        this.domObserver = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
                    this.queueDomScan();
                    return;
                }
            }
        });
        this.domObserver.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }
    queueDomScan() {
        if (this.domScanQueued) {
            return;
        }
        this.domScanQueued = true;
        window.requestAnimationFrame(() => {
            this.domScanQueued = false;
            void this.initRenderedBlocks();
        });
    }
    onEditorBlockPreviewRender(blockElement, attributes) {
        return __awaiter(this, void 0, void 0, function* () {
            const blockName = attributes === null || attributes === void 0 ? void 0 : attributes.name;
            if (!blockName || !blockName.startsWith("acf/")) {
                return;
            }
            const normalizedElement = this.extractHTMLElement(blockElement);
            if (!normalizedElement) {
                return;
            }
            const blockId = this.extractBlockId(blockElement);
            if (blockId && this.adminBlocks[blockId]) {
                if (this.adminReInitRequired.includes(blockName)) {
                    yield this.loadBlockClass(blockName);
                    this.adminBlocks[blockId] = this.initBlock(blockName, normalizedElement);
                    return;
                }
                this.adminBlocks[blockId].adminReInit();
                return;
            }
            yield this.loadBlockClass(blockName);
            const blockInstance = this.initBlock(blockName, normalizedElement);
            if (blockId) {
                this.adminBlocks[blockId] = blockInstance;
            }
        });
    }
    extractBlockId(blockElement) {
        if (typeof (blockElement === null || blockElement === void 0 ? void 0 : blockElement.id) === "string" && blockElement.id.length > 0) {
            return blockElement.id;
        }
        const htmlElement = this.extractHTMLElement(blockElement);
        if (htmlElement && htmlElement.id) {
            return htmlElement.id;
        }
        return null;
    }
    getRenderedBlockKeys() {
        const keys = new Set();
        const renderedBlocks = window.__RENDERED_BLOCKS__;
        if (Array.isArray(renderedBlocks)) {
            renderedBlocks.forEach((blockKey) => {
                if (typeof blockKey === "string" && blockKey.startsWith("acf/")) {
                    keys.add(blockKey);
                }
            });
        }
        // Also detect from DOM for editor iframe and preview-only contexts.
        Object.keys(this.blockMap).forEach((blockKey) => {
            if (!blockKey.startsWith("acf/")) {
                return;
            }
            const blockSlug = blockKey.substring(4);
            if (document.querySelector("." + blockSlug)) {
                keys.add(blockKey);
            }
        });
        return Array.from(keys);
    }
    initBlockInstancesInDom(blockKey) {
        if (!blockKey.startsWith("acf/")) {
            return;
        }
        const blockSlug = blockKey.substring(4);
        const blockList = document.querySelectorAll("." + blockSlug);
        blockList.forEach((blockElement) => {
            if (this.initializedElements.has(blockElement)) {
                return;
            }
            this.blocks.push(this.initBlock(blockKey, blockElement));
            this.initializedElements.add(blockElement);
        });
    }
    loadBlockClass(blockKey) {
        return __awaiter(this, void 0, void 0, function* () {
            // Return cached class if already loaded
            if (this.loadedBlockClasses[blockKey]) {
                return this.loadedBlockClasses[blockKey];
            }
            const loader = this.blockMap[blockKey];
            if (!loader) {
                // Fallback to base Block class
                this.loadedBlockClasses[blockKey] = Block;
                return Block;
            }
            try {
                const BlockClass = yield loader();
                this.loadedBlockClasses[blockKey] = BlockClass;
                return BlockClass;
            }
            catch (error) {
                console.error(`Failed to load block ${blockKey}:`, error);
                // Fallback to base Block class
                this.loadedBlockClasses[blockKey] = Block;
                return Block;
            }
        });
    }
    /**
     *
     * @param blockType Block type from how acf sees them like acf/video
     * @param element HTMLElement or jQuery-like object
     * @returns
     */
    initBlock(blockType, element) {
        const normalizedElement = this.extractHTMLElement(element);
        const BlockClass = this.loadedBlockClasses[blockType];
        if (!normalizedElement) {
            console.warn(`Could not resolve HTMLElement for block ${blockType}`);
            return new Block(element);
        }
        if (!BlockClass) {
            // Fallback to base Block class
            return new Block(normalizedElement);
        }
        return new BlockClass(normalizedElement);
    }
    extractHTMLElement(element) {
        if (element instanceof HTMLElement) {
            return element;
        }
        if (element && element[0] instanceof HTMLElement) {
            return element[0];
        }
        if ((element === null || element === void 0 ? void 0 : element.prevObject) && element.prevObject[0] instanceof HTMLElement) {
            return element.prevObject[0];
        }
        return null;
    }
    getBlocks(className) {
        return this.blocks.filter((block) => block.name() == className);
    }
    getBlock(className) {
        return this.blocks.filter((block) => block.name() == className)[0];
    }
}
